import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';
import { CircularProgressProps } from '@mui/material/CircularProgress';

const useStyles = makeStyles()(theme => ({
  wrapper: {
    position: 'relative',
  },
  'kind-full-width': {
    width: '100%',
  },
  buttonProgress: {
    top: '50%',
    left: '50%',
    position: 'absolute',
    marginTop: -12,
    marginLeft: -12,
    color: theme.palette.ok.light,
  },
}));

type LoadingButtonKind = 'full-width';
interface Props {
  loading?: boolean;
  disabled?: boolean;
  buttonProps?: ButtonProps & { testLocator?: string };
  circularProgressProps?: CircularProgressProps;
  kind?: LoadingButtonKind;
  testLocator?: string;
}

const LoadingButton: React.FC<Props> = React.forwardRef<
  HTMLButtonElement,
  Props
>(
  (
    {
      loading = false,
      disabled = false,
      children,
      buttonProps = {
        variant: 'contained',
        color: 'primary',
        fullWidth: false,
      },
      circularProgressProps = { size: 24 },
      kind,
      testLocator,
    },
    ref,
  ) => {
    const { classes, cx } = useStyles();

    return (
      <div
        className={cx(classes.wrapper, {
          [classes[`kind-${kind}`]]: Boolean(kind),
        })}
        data-test-locator={testLocator}
      >
        <Button
          ref={ref}
          disabled={loading || disabled}
          data-test-locator={buttonProps.testLocator}
          {...buttonProps}
        >
          {children}
        </Button>
        {loading && (
          <CircularProgress
            className={classes.buttonProgress}
            {...circularProgressProps}
          />
        )}
      </div>
    );
  },
);

export { LoadingButton };
